import { createAction } from "redux-actions";
import {
  fetchGalleryTypes,
  galleryVotingTypes,
  getClientSettingTypes,
  storeDataTypes,
  trackContentViewTypes,
} from "./gallery.types";

export const getClientSettingRequest = createAction(
  getClientSettingTypes.GET_CLIENT_SETTING_REQUEST
);
export const getClientSettingSucceeded = createAction(
  getClientSettingTypes.GET_CLIENT_SETTING_SUCCEEDED
);
export const getClientSettingFailed = createAction(
  getClientSettingTypes.GET_CLIENT_SETTING_FAILED
);
export const getClientSettingEnd = createAction(
  getClientSettingTypes.GET_CLIENT_SETTING_END
);

export const galleryVotingRequest = createAction(
  galleryVotingTypes.GALLERY_VOTING_REQUEST
);
export const galleryVotingSucceeded = createAction(
  galleryVotingTypes.GALLERY_VOTING_SUCCEEDED
);
export const galleryVotingFailed = createAction(
  galleryVotingTypes.GALLERY_VOTING_FAILED
);
export const galleryVotingEnd = createAction(
  galleryVotingTypes.GALLERY_VOTING_END
);

export const trackContentViewRequest = createAction(
  trackContentViewTypes.TRACK_CONTENT_VIEW_REQUEST
);
export const trackContentViewSucceeded = createAction(
  trackContentViewTypes.TRACK_CONTENT_VIEW_SUCCEEDED
);
export const trackContentViewFailed = createAction(
  trackContentViewTypes.TRACK_CONTENT_VIEW_FAILED
);
export const trackContentViewEnd = createAction(
  trackContentViewTypes.TRACK_CONTENT_VIEW_END
);

export const fetchGalleryRequest = createAction(
  fetchGalleryTypes.FETCH_GALLERY_REQUEST
);
export const fetchGallerySucceeded = createAction(
  fetchGalleryTypes.FETCH_GALLERY_SUCCEEDED
);
export const fetchGalleryFailed = createAction(
  fetchGalleryTypes.FETCH_GALLERY_FAILED
);
export const fetchGalleryEnd = createAction(
  fetchGalleryTypes.FETCH_GALLERY_END
);

export const storeDataRequest = createAction(storeDataTypes.STORE_DATA_REQUEST);
